import { useState, useEffect, useCallback, useRef } from 'react';
import { collection, query, where, onSnapshot, addDoc, updateDoc, doc, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';

export default function useInvites(userId) {
  const [pendingInvites, setPendingInvites] = useState([]);
  const unsubRef = useRef(null);

  // Listen for invites sent to this user
  useEffect(() => {
    if (!userId) {
      setPendingInvites([]);
      return;
    }

    const q = query(
      collection(db, 'invites'),
      where('toUserId', '==', userId),
      where('status', '==', 'pending')
    );

    unsubRef.current = onSnapshot(q, (snapshot) => {
      const invites = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      setPendingInvites(invites);
    });

    return () => {
      if (unsubRef.current) unsubRef.current();
    };
  }, [userId]);

  const sendInvite = useCallback(async (gameId, gameCode, fromName, toUserId, toUserName) => {
    // Check if invite already exists
    const q = query(
      collection(db, 'invites'),
      where('gameId', '==', gameId),
      where('toUserId', '==', toUserId),
      where('status', '==', 'pending')
    );
    const existing = await getDocs(q);
    if (!existing.empty) return;

    await addDoc(collection(db, 'invites'), {
      gameId,
      gameCode,
      fromName,
      toUserId,
      toUserName,
      status: 'pending',
      createdAt: new Date()
    });
  }, []);

  const acceptInvite = useCallback(async (inviteId) => {
    await updateDoc(doc(db, 'invites', inviteId), { status: 'accepted' });
  }, []);

  const declineInvite = useCallback(async (inviteId) => {
    await updateDoc(doc(db, 'invites', inviteId), { status: 'declined' });
  }, []);

  return { pendingInvites, sendInvite, acceptInvite, declineInvite };
}
